import { db } from '../../../config/firebase';
import { useState } from 'react';
import "./Registerations.css";
  
const Registerations = () => {
  
    const [info , setInfo] = useState([]);
  
    window.addEventListener('load', () => {
        Fetchdata();
      });

    const Fetchdata = ()=>{
        db.collection("contacts").get().then((Snapshot) => {
             
            Snapshot.forEach(e => {
                var data = e.data();
                setInfo(arr => [...arr , data]);
            });
        })
    }
      
    return (
        <div>
            <>
            <h2 style={{textAlign: "center"}}>Registerations</h2>
            </>
          
        {
            info.map((data) => (
            <Info Name={data.name} 
                   Contact={data.contact} 
                   Age={data.age}
                   Email={data.email}
                   Profession={data.profession}
                   />
            ))
        }
        </div>
  
    );
}
  

const Info = ({Contact , Name, Age, Email, Profession}) => {
    return (
        <>
            <div className="webinar-card">
              <p>Name : {Name}</p>               
              <p>Age : {Age}</p>              
              <p>Contact : {Contact}</p>
              <p>Email : {Email}</p>
              <p>Profession : {Profession}</p>
            </div>
        </>
    );
}
  
export default Registerations;